import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from "@shared/store/dialog.duck";
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import Calendar from '@shared/ui/molecules/calendar/Calendar';
import moment, { Moment } from "moment";
import { selectActiveDay, setActiveDay } from "../../../store/editMovements.duck";
import { setCalendarDate } from "@shared/store/dashboard.duck";
import { warningNotification } from '@shared/store/notification.duck';
import {
  hiddenPastWhereaboutsMessage,
  useHidePastWhereaboutsCutoff,
} from '@shared/hooks/UseHidePastWhereaboutsCutoff';

export default function ChangeCalendarDateDialog() {
  const dispatch = useDispatch();
  const activeDay = useSelector(selectActiveDay);
  const { minDate, weeksLimit } = useHidePastWhereaboutsCutoff();

  const close = () => {
    dispatch(closeDialog());
  }

  const onDateSelect = (dateSelect: Moment) => {
    if (minDate && dateSelect.isBefore(minDate)) {
      dispatch(warningNotification(hiddenPastWhereaboutsMessage(weeksLimit)));
      return;
    }
    dispatch(setActiveDay(dateSelect));
    dispatch(setCalendarDate(dateSelect));
    close();
  }

  return (
    <Dialog isOpen={true} onClose={() => close()}>
      <DialogHeader title={'button.choose-day'} />

      <Calendar onDateSelect={onDateSelect} activeDate={activeDay}
                initialDate={activeDay ?? moment()}
                style={{margin: '0 auto'}}
                highlightToday={true}
                hideActiveDayHighlight={false} />
    </Dialog>
  )
}
